import MenuItem from '@material-ui/core/MenuItem';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import debounce, { getLinkId } from 'Services/tools';
import { getQuizz, searchQuizz } from 'FD/quizz/actions';
import TextField from '@material-ui/core/TextField';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Autosuggest from 'react-autosuggest';

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: '10',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    left: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

@injectIntl
@withStyles(styles)
@connect(store => ({
  quizzes: store.quizzList.search || [],
}))
export class QuizzInput extends Component {
  state = {
    searchText: '',
    suggestions: [],
  };

  componentDidMount() {
    const { input, dispatch } = this.props;

    if (input.value) {
      const id = getLinkId(input.value);

      dispatch(getQuizz(id)).then(data => {
        this.setState({
          searchText: this.getSuggestionValue(data.payload),
        });
      });
    }
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { input } = this.props;
    if (!next.input || !input) {
      return true;
    }
    if (input.value != next.input.value && !next.input.value) {
      this.setState({ searchText: '' });
    }
  }

  handleSuggestionsFetchRequested = debounce(({ value }) => {
    const { dispatch } = this.props;
    dispatch(searchQuizz(value)).then(() => {
      this.setState({
        suggestions: this.getSuggestions(value),
      });
    });
  }, 500);

  handleChange = (event, value) => {
    this.setState({
      searchText: value.newValue,
    });
  };

  handleSuggestionSelected = (event, { suggestion }) => {
    const { useObject } = this.props;
    if (useObject) {
      this.props.input.onChange(suggestion);
    } else {
      this.props.input.onChange(suggestion.id);
    }
  };

  renderInput = inputProps => {
    const { classes, className, value, ref, label, hintText, ...other } = inputProps;

    return (
      <TextField
        className={className}
        value={value}
        inputRef={ref}
        label={label}
        fullWidth
        InputProps={{
          classes: {
            input: classes.input,
          },
          placeholder: hintText || label,
          ...other,
        }}
      />
    );
  };

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const label = this.getSuggestionValue(suggestion);
    const matches = match(label, query);
    const parts = parse(label, matches);

    return (
      <MenuItem selected={isHighlighted} component="div">
        <div>
          {parts.map((part, index) =>
            part.highlight ? (
              <span key={index} style={{ fontWeight: 300 }}>
                {part.text}
              </span>
            ) : (
              <strong key={index} style={{ fontWeight: 500 }}>
                {part.text}
              </strong>
            )
          )}
        </div>
      </MenuItem>
    );
  };

  renderSuggestionsContainer = options => {
    const { containerProps, children } = options;

    return (
      <div>
        {children && (
          <Paper {...containerProps} square>
            {children}
          </Paper>
        )}
      </div>
    );
  };
  getSuggestionValue = suggestion => `${suggestion.title} (${suggestion.id})`;

  getSuggestions = value => {
    const { quizzes } = this.props;
    const inputLength = value.trim().length;
    return inputLength === 0 ? [] : quizzes.collection;
  };

  render() {
    const {
      input,
      labelKey,
      hintText,
      intl: { formatMessage: f },
      className,
      classes,
    } = this.props;

    const { searchText, suggestions } = this.state;

    const label = labelKey ? f({ id: labelKey }) : f({ id: `field_${input.name}` });
    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={this.renderInput}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          value: searchText || '',
          onChange: this.handleChange,
          autoFocus: input.autoFocus,
          className,
          classes,
          label,
          hintText,
        }}
      />
    );
  }
}
